import { Grid, Stack } from '@mui/material';
import exportFromJSON from 'export-from-json';
import { Fragment } from 'react';
import DataTable from 'react-data-table-component';
import { AuditLogReportRequest, EnrollmentReportItem } from '../../../model/auditlogreports';
import ReportHeader from './ReportHeader';
import ReportToolbar from './ReportToolbar';
import useUserEnrollments from '../../../hooks/AuditLogReports/useUserEnrollments';

const UserEnrollments = ({ request, reportType, filterBy, users }: props) => {

    const { status, data, error, isFetching } = useUserEnrollments(request);

    const columns = [
        {
            name: 'User Name',
            selector: (row: EnrollmentReportItem) => row.userName,
        },
        {
            name: 'Enrollment Group',
            selector: (row: EnrollmentReportItem) => row.enrollmentGroups,
        },
        {
            name: 'Enrolled Date - Time',
            selector: (row: EnrollmentReportItem) => row.enrollmentDate,
        },
        {
            name: 'Location / Store',
            selector: (row: EnrollmentReportItem) => row.location,
        },
        {
            name: 'Reported Loss',
            selector: (row: EnrollmentReportItem) => row.reportedLoss,
        },
        {
            name: 'Case Event Type',
            selector: (row: EnrollmentReportItem) => row.caseEventType || '',
        },
        {
            name: 'Case / Subject',
            selector: (row: EnrollmentReportItem) => row.caseNumber || '',
        },
        {
            name: 'Status',
            selector: (row: EnrollmentReportItem) => row.enrollmentStatus,
        },
        {
            name: 'Approved By',
            selector: (row: EnrollmentReportItem) => row.approverName
        },
        {
            name: 'Approved Date - Time',
            selector: (row: EnrollmentReportItem) => row.approvalDate,
        }
    ];

    const exportApproverEnrollmentsData = () => {
        const reportData = data || [];
        const fileName = 'UserEnrollments';
        const exportType = exportFromJSON.types.csv;

        const fields = {
            userName: 'User Name',  enrollmentGroups: 'Enrollment Groups', enrollmentDate: 'Enrolled DateTime',
            location: 'Location / Store', reportedLoss: 'Reported Loss', caseEventType: 'Case Event Type',
            caseNumber: 'Case / Subject', enrollmentStatus: 'Status', approverName: "Approved By",
            approvalDate: 'Approved DateTime'
        };

        exportFromJSON({
            data: reportData,
            fileName: fileName,
            fields: fields,
            exportType: exportType
        });
    };

    return (
        <Fragment>
            <Grid container>
                <Grid item xs={5}>
                </Grid>
                <Grid item xs={6}>
                    <ReportHeader reportType={reportType} filterBy={filterBy} users={users} />
                </Grid>
                <Grid item xs={1}>
                    <ReportToolbar export={exportApproverEnrollmentsData} />
                </Grid>
            </Grid>

            <DataTable
                columns={columns}
                data={data || []}
                fixedHeader={true}
                fixedHeaderScrollHeight={'750px'}
                pagination
            />
        </Fragment>
    );
}

type props = {
    request: AuditLogReportRequest;
    reportType: any
    filterBy: any
    users: any
}

export default UserEnrollments;